import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../../hooks/useNavConfig';
import { AccountExtraLink } from '../AccountExtrasLink';
import { selectHubspotCreditsStatus } from './selectors';
import { useAppSelector } from '../../../../hooks/redux';
import { useHubspotCreditsData } from './hooks/useHubspotCreditsData';
import { keyframes } from 'styled-components';
import styled, { css } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadingAnimation = keyframes(["0%{background-color:hsl(200,20%,80%);}100%{background-color:hsl(200,20%,95%);}"]);
const SkeletonContainer = styled.div.withConfig({
  displayName: "HubSpotCreditsLink__SkeletonContainer",
  componentId: "sc-7sno0x-0"
})(({
  theme
}) => {
  return css(["padding:", " ", " !important;width:100%;"], theme.space['200'], theme.space['500']);
});
const AnimatedDiv = styled.div.withConfig({
  displayName: "HubSpotCreditsLink__AnimatedDiv",
  componentId: "sc-7sno0x-1"
})(({
  theme
}) => {
  return css(["animation:", " 1s linear infinite alternate;width:100%;height:15px;border-radius:", ";&:first-of-type{width:100% !important;}&:last-of-type{width:80%;margin-top:", " !important;}"], loadingAnimation, theme.borderRadius['100'], theme.space['200']);
});
const HubSpotCreditsLink = ({
  portalId
}) => {
  var _creditsStatus$isAccu, _creditsStatus$isEnab;
  const {
    t
  } = useTranslation();
  const creditsStatus = useAppSelector(selectHubspotCreditsStatus);
  const isAccurate = (_creditsStatus$isAccu = creditsStatus === null || creditsStatus === void 0 ? void 0 : creditsStatus.isAccurate) !== null && _creditsStatus$isAccu !== void 0 ? _creditsStatus$isAccu : false;
  const isEnabled = (_creditsStatus$isEnab = creditsStatus === null || creditsStatus === void 0 ? void 0 : creditsStatus.isEnabled) !== null && _creditsStatus$isEnab !== void 0 ? _creditsStatus$isEnab : false;
  const displayCreditsIndicator = isEnabled && isAccurate;
  const {
    creditDisplayText,
    isLoading,
    hasError
  } = useHubspotCreditsData({
    displayCreditsIndicator
  });
  if (!isAccurate || !isEnabled || hasError) {
    return null;
  }
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "hubspotCredits",
    link: `${getFullUrl('app')}/account-and-billing/${portalId}/usage/hubspot-credits`,
    linkText: t('nav.account.credits.title'),
    secondaryText: creditDisplayText,
    isNewItem: true,
    isLoading: isLoading,
    loadingIndicator: /*#__PURE__*/_jsxs(SkeletonContainer, {
      "data-test-id": "credits__loading-indicator",
      children: [/*#__PURE__*/_jsx(AnimatedDiv, {}), /*#__PURE__*/_jsx(AnimatedDiv, {})]
    })
  });
};
export default HubSpotCreditsLink;